import { computed, Injectable, signal } from '@angular/core';

const SHOW_DELAY_MS = 200;

@Injectable({ providedIn: 'root' })
export class HttpLoadingService {
  private readonly activeCount = signal(0);
  private readonly visible = signal(false);
  private showTimer: ReturnType<typeof setTimeout> | null = null;

  readonly loading = computed(() => this.visible());

  begin(): void {
    const next = this.activeCount() + 1;
    this.activeCount.set(next);

    if (next === 1) {
      this.scheduleShow();
    }
  }

  end(): void {
    const next = Math.max(0, this.activeCount() - 1);
    this.activeCount.set(next);

    if (next === 0) {
      this.clearShowTimer();
      this.visible.set(false);
    }
  }

  private scheduleShow(): void {
    this.clearShowTimer();
    this.showTimer = setTimeout(() => {
      if (this.activeCount() > 0) {
        this.visible.set(true);
      }
    }, SHOW_DELAY_MS);
  }

  private clearShowTimer(): void {
    if (this.showTimer != null) {
      clearTimeout(this.showTimer);
      this.showTimer = null;
    }
  }
}
